<div class="toolbar-container">
  <mat-toolbar class="toolbar">
    <!-- <button mat-icon-button (click)= "toggleMenu()" aria-label="menu" class="menu-button">
      <mat-icon class="styleMenu">menu</mat-icon>
    </button> -->
    
    <div  class="header-container" (click)="homeScreenRoute()">
   
      <img alt="img" class="toolbar-img" src="./assets/DeloitteLogo.png" />
 
    <div class="partition-pipe">|</div>
    <span class="toolbar-text" >Config Execution Agent</span>

 
   </div>
   <span class="alignRight"></span>



    <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;" >
      <ng-container *ngIf="adminDashboardButtonEnablement()">

        <button mat-button class="adminButton" (click)="navigateToAdminDashboard()">
          <!-- <mat-icon>open_in_new</mat-icon> -->
           <img class="admin-route-icon" src='../../../../assets/adminRoute.png'>
          <span class="admin-dashboard-text"> Admin Dashboard</span>
        </button>
      </ng-container>
      <div *ngIf="currentUrl==='/'" style="width: 128px; margin-left: 25px; margin-right: 25px;"></div>
      <div #userIcon class="user-icon" (mouseenter)="openUserPopup()"  *ngIf="logOutButtonEnablement()">
        {{ userData?.userName?.charAt(0).toUpperCase()}}{{ userData?.userName?.charAt(1).toUpperCase()}}
      </div>
    </div>


    <mat-list *ngIf="showMenu" id="toolbarMenu">
      <mat-list-item (click)="showSubMenu = !showSubMenu" class="parent" [ngClass]="{ 'active-menu': showSubMenu }">
        <img alt="img" src="./assets/quick-link-active.svg" *ngIf="showSubMenu" class="left-icon" />
        <img alt="img" src="./assets/quick-link-original.svg" *ngIf="!showSubMenu" class="left-icon" />
        <span class="full-width">Quick Links</span>
        <mat-icon class="menu-button" *ngIf="!showSubMenu">add</mat-icon>
        <mat-icon class="menu-button minus-icon" *ngIf="showSubMenu">minimize</mat-icon>
      </mat-list-item>
      <div *ngIf="showSubMenu" class="sub-menu">
        <a href="/" menu-list-item (click)="toggleMenu()">
          <button mat-button class="btn">DFTE Portal</button>
        </a>
        <a (click)="downloadFile()" menu-list-item>
          <button mat-button class="btn">User Guide</button>
        </a>
        <a (click)="playVideo()" menu-list-item>
          <button mat-button class="btn">Videos</button>
        </a>
      </div>

      <mat-list-item (click)="showSupportMenu = !showSupportMenu" class="parent"
        [ngClass]="{ 'active-menu': showSupportMenu }">
        <img alt="img" src="./assets/support-active.svg" *ngIf="showSupportMenu" class="left-icon" />
        <img alt="img" src="./assets/support.svg" *ngIf="!showSupportMenu" class="left-icon" />
        <span class="full-width">Support</span>
        <mat-icon class="menu-button" *ngIf="!showSupportMenu">add</mat-icon>
        <mat-icon class="menu-button minus-icon" *ngIf="showSupportMenu">minimize</mat-icon>
      </mat-list-item>

      <div *ngIf="showSupportMenu" class="sub-menu">
        <a [href]="mailDetails" menu-list-item (click)="toggleMenu()">
          <button mat-button class="btn">Contact Us</button>
        </a>
      </div>

      <mat-list-item (click)="showPrivacyMenu = !showPrivacyMenu" class="parent"
        [ngClass]="{ 'active-menu': showPrivacyMenu }">
        <img alt="img" src="./assets/Privacy.svg" *ngIf="showPrivacyMenu" class="left-icon" />
        <img alt="img" src="./assets/Privacy-white.svg" *ngIf="!showPrivacyMenu" class="left-icon" />
        <span class="full-width">Privacy Notice</span>
        <mat-icon class="menu-button" *ngIf="!showPrivacyMenu">add</mat-icon>
        <mat-icon class="menu-button minus-icon" *ngIf="showPrivacyMenu">minimize</mat-icon>
      </mat-list-item>
      <div *ngIf="showPrivacyMenu" class="sub-menu">
        <a menu-list-item target="_blank" [href]="pdfUrl" (click)="toggleMenu()">
          <button mat-button class="btn">DFTE Privacy Notice</button>
        </a>
      </div>

      <mat-list-item (click)="showCookieMenu = !showCookieMenu" class="parent"
        [ngClass]="{ 'active-menu': showCookieMenu }">
        <img alt="img" src="./assets/cookie.svg" *ngIf="showCookieMenu" class="left-icon" />
        <img alt="img" src="./assets/cookie-white.svg" *ngIf="!showCookieMenu" class="left-icon" />
        <span class="full-width">Cookies</span>
        <mat-icon class="menu-button" *ngIf="!showCookieMenu">add</mat-icon>
        <mat-icon class="menu-button minus-icon" *ngIf="showCookieMenu">minimize</mat-icon>
      </mat-list-item>
      <div *ngIf="showCookieMenu" class="sub-menu">
        <a menu-list-item href="https://cookienotice.deloitte.com" (click)="toggleMenu()" target="_blank" rel="noopener"
          aria-label="More information about your privacy">
          <button mat-button class="btn">Cookies</button>
        </a>
        <a menu-list-item (click)="openCookieSettings()">
          <button mat-button class="btn">Cookies Settings</button>
        </a>
      </div>
    </mat-list>
  </mat-toolbar>
  <ng-container *ngIf="isPopupOpen"  class="popup-overlay"  >
    <div class="popup" #popup>
      <div class="popup-content"  (mouseenter)="openUserPopup()" (mouseleave)=" closeUserPopup()">
        <div class="box" >
          <span class="popup-user-icon">
            {{ userData.userName.charAt(0).toUpperCase() }}{{ userData.userName.charAt(1).toUpperCase() }}
          </span>
          <span class="popup-username">
            {{ userData.userName }}
            <div class="popup-email">
              {{ userData.email }}
            </div>
          </span>
        </div>
        <button mat-stroked-button color="primary" class="logout-button" (click)="logout()">
          <mat-icon class="logout-icon">logout</mat-icon> Log Out
        </button>
      </div>
    </div>
  </ng-container>

</div>